import { Drawer, Modal, Typography } from "antd";
import React from "react";
import CustomButton from "../../../resuableComponents/CustomButton";
import "./errorModal.css";

const ErrorModal = ({
  icon,
  title,
  desc,
  showModal,
  primaryOnClick,
  secondaryOnClick,
  primaryBtnText,
  secondaryBtnText,
  showSecondaryButton,
  showPrimaryButton = true,
  asBottomSheet = false,
  onClose,
  children,
}) => {
  const content = (
    <div className="domestic-error-root">
      <div className="domestic-error-header-conatiner">
        <div className="domestic-error-header-logo">{icon}</div>
        <div className="domestic-error-header-content dynamic-font-styling">
          <Typography className="domestic-error-header-title">
            {title}
          </Typography>
          <Typography
            className="domestic-error-header-desc"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {desc}
          </Typography>
        </div>
      </div>
      {children}
      <div className="domestic-error-footer">
        {showSecondaryButton && (
          <CustomButton
            buttonType={"primary-btn"}
            containerType={""}
            padding={"5px 15px"}
            onClick={secondaryOnClick}
            text={secondaryBtnText}
          />
        )}
        {
          showPrimaryButton && (
            <CustomButton
              text={primaryBtnText}
              buttonType={"primary-btn"}
              padding={"5px 15px"}
              block={asBottomSheet}
              onClick={primaryOnClick}
            />
          )
        }
      </div>
    </div>
  );

  // Mobile: a bottom sheet instead of a centered modal.
  if (asBottomSheet) {
    return (
      <Drawer
        placement="bottom"
        open={showModal}
        closable={false}
        onClose={onClose}
        className="domestic-error-drawer"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Modal
      centered
      open={showModal}
      footer={null}
      closable={false}
      width={"416px"}
    >
      {content}
    </Modal>
  );
};

export default ErrorModal;
